/** Left navigation (desktop: full or collapsed rail; tablet: rail that opens as a drawer; hidden on phones). */
import clsx from 'clsx';
import { PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import { Link, NavLink } from 'react-router';
import { useIsDesktop } from '../lib/media.js';
import styles from './AppShell.module.css';
import type { NavItem } from './nav.js';

export interface SidebarProps {
  items: readonly NavItem[];
  /** Tablet drawer state. */
  open: boolean;
  /** Desktop collapsed (rail) state. */
  collapsed: boolean;
  onToggle: () => void;
}

export function Sidebar({ items, open, collapsed, onToggle }: SidebarProps) {
  const isDesktop = useIsDesktop();
  const expanded = isDesktop ? !collapsed : open;
  const toggleLabel = isDesktop ? (collapsed ? 'Zijbalk uitklappen' : 'Zijbalk inklappen') : open ? 'Menu sluiten' : 'Menu uitklappen';

  return (
    <nav className={styles.sidebar} data-open={open} aria-label="Hoofdmenu">
      <Link to="/" className={styles.brand} aria-label="TransectLibre – startpagina">
        <img src="/brand/transect-icon.svg" alt="" width={34} height={34} className={styles.brandIcon} />
        <span className={styles.brandText}>
          <span className={styles.brandName}>TransectLibre</span>
          <span className={styles.brandSub}>Planning opgravingsteam</span>
        </span>
      </Link>
      <ul className={styles.navList}>
        {items.map((item) => (
          <li key={item.to}>
            <NavLink to={item.to} className={({ isActive }) => clsx(styles.navLink, isActive && styles.navActive)} title={item.label}>
              <item.icon aria-hidden="true" />
              <span className={styles.navLabel}>{item.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
      <button type="button" className={styles.collapseButton} onClick={onToggle} aria-label={toggleLabel} title={toggleLabel} aria-expanded={expanded}>
        {expanded ? <PanelLeftClose aria-hidden="true" /> : <PanelLeftOpen aria-hidden="true" />}
        <span className={styles.navLabel}>{expanded ? 'Inklappen' : 'Uitklappen'}</span>
      </button>
    </nav>
  );
}
